/**
 * Handles all product listings and search pages.
 */


"use strict";

import GTMHelper from "./gtm-helper";
import Toolbox from "./toolbox";
import { openingToNewTab } from "./helpers";
import { itemListingConfigModifier } from "./listing-helper";
import ProductFetcherHandler from "./listing-product-fetcher";
import PriceHistoryHandler from "./price-history";
import ItemListingListenersHandler from "./listing-listener-handler";
import ListingFilterHandler from "./listing-filter-handler";
import ListingActionsHandler from "./listing-actions";
import ListingAnalyticsHelper from "./listing-analytics";
import { updateProductListItemPositions } from "./product-list-item";

class ProductListings {

	init() {

		if (!document.querySelector(".custom-category-listing") || !document.querySelector(".filter-bar")) {
			return;
		}

		PriceHistoryHandler.init();


		/* Default listing overrides. */

		const _state = {
			promoItemCounters: {
				promoItemCounter: 0,
				itemCounter: 0,
				hasPromoItems: false,
				promoItemShowAfterEvery: 8,
				promoItemStartPosition: 4, // Will be between -2 and +1 of this value. Ensures that promo is visible near top.
				promoItemRandomRange: 2,
				itemsBetweenPromosCounter: 0,
				minItemsBetweenPromos: 6,
				maxItemsBetweenPromos: 10,
				showMaxPromoItems: 1,
				selectedPromoIndex: 0
			},
			promoItems: []
		};

		const _config = {
			filterDataSelector: "data-product-list-filters",
			listingSelector: ".custom-category-listing",
			itemListingActionsSelector: ".product-list-actions",
			listingItemCountSelector: ".product-count",
			listingItemCountWithTextSelector: ".product-count-text",
			listingRemainingItemsCountSelector: ".remaining-products-count",
			listingItemType: "tuote",
			listingItemTypePlural: "tuotetta",
			filterColumnSelector: ".custom-product-filters-col",
			loadMoreLink: ".custom-product-list-load-more",
			noListingItems: '<p class="no-listing-items">Tuotteita ei voitu ladata.</p>',
			searchListing: "products", // packages
			endpoint: "/stage-ajax/getCategoryProducts/"
		};

		const state = itemListingConfigModifier.modify(_state, "state");
		const config = itemListingConfigModifier.modify(_config, "config");
		itemListingConfigModifier.loadConfig();


		//config.endpoint = "/stage-ajax/getSelectionGuides/";
		const itemFetcher = new ProductFetcherHandler(state, config); //ItemFetcherHandler; ProductFetcherHandler
		ItemListingListenersHandler.init({ itemsFetcher: itemFetcher });
		ListingFilterHandler.init();
		ListingActionsHandler.init();


		if (document.querySelector("body.budjettipaivat-page")) {
			config.useCampaignAnalytics = true;
			ListingAnalyticsHelper.init();
		}

		ListingFilterHandler.loadFilterSet();
		if (itemFetcher.productListPromotions) {
			itemFetcher.productListPromotions.addPromotionItemsToList();
		}
		ListingFilterHandler.restoreFromSessionStorage();

		function productListListeners() {

			document.querySelector(config.listingSelector).addEventListener("click", (e) => {
				const clickedElement = e.target;

				const clickedPriceHistoryPanel = Toolbox.closest(clickedElement, ".price-history-panel");
				if (clickedPriceHistoryPanel && clickedElement.tagName !== "BUTTON") {
					return;
				}
				if (clickedElement.tagName !== "BUTTON") {
					const clickedProduct = Toolbox.closest(clickedElement, ".product-list-item");
					if (clickedProduct && !clickedProduct.classList.contains("product-list-promo")) {
						ListingFilterHandler.saveToSessionStorage();

						const productLink = clickedProduct.querySelector(".product-link");
						if (GTMHelper.isEnabled()) {
							const listItem = Toolbox.closest(e.target, ".product-list-item");
							if (!listItem.getAttribute("data-position")) {
								updateProductListItemPositions();
							}

							const productObject = {
								id: listItem.dataset.id,
								price: listItem.dataset.price,
								brand: listItem.dataset.brand,
								name: listItem.dataset.name,
								color: listItem.dataset.colorName,
								category: document.querySelector(".js-product-list").dataset.productListId, //listing.data("product-list-id");
								link: productLink.getAttribute("href"),
								list: "Tuotelistaus",
								position: listItem.dataset.position ? parseInt(listItem.dataset.position) : 0
							};

							if (productObject.id) {
								const newTab = openingToNewTab(e);
								if (!newTab) {
									// Prevent actual click event if not opening to new tab (so that datalayer has the time to receive the event)
									// Opening to new tab is allowed, because tag manager event will not be interrubted
									e.preventDefault();
								} else {
									e.stopPropagation();
								}

								GTMHelper.clickProduct(productObject.id, productObject.name, productObject.price, productObject.brand, productObject.category, productObject.color, productObject.link, productObject.list, null, productObject.position, newTab);
							}
						}
					}

				} else if (clickedElement.tagName === "BUTTON" && (clickedElement.classList.contains("open-button") || clickedElement.classList.contains("close-button"))) {
					PriceHistoryHandler.showPriceHistory(clickedElement, { mode: "listing" });
				}

			});
		}

		function productImpressionsListener() {
			let productImpressions = [];
			//categoryDebugData.productImpressions = [];
			let timeout = null;
			document.addEventListener("lazyloaded", (e) => {

				const productItem = Toolbox.closest(e.target, ".product-list-item");

				if (productItem) {
					productItem.classList.remove("fade");
					const listing = Toolbox.closest(productItem, ".js-product-list");
					if (productItem.dataset.id && listing) {
						if (!productItem.getAttribute("data-position")) {
							updateProductListItemPositions();
						}

						productImpressions.push({
							id: productItem.dataset.id,
							price: productItem.dataset.price,
							brand: productItem.dataset.brand,
							name: productItem.dataset.name,
							category: listing.dataset.productListId,
							variant: productItem.dataset.colorName,
							list: "Tuotelistaus",
							position: productItem.dataset.position ? parseInt(productItem.dataset.position) : 0,
							dimension23: productItem.dataset.id + "_" + productItem.dataset.color
						});

						if (timeout) {
							clearTimeout(timeout);
						}

						timeout = setTimeout(() => {
							if (GTMHelper.isEnabled()) {
								GTMHelper.productImpressions(productImpressions);
								productImpressions = [];
							}
						}, 5000);
					}
				}

			}, Toolbox.listenerOptions());
		}

		// Add listeners.
		ItemListingListenersHandler.addListeners([productListListeners, productImpressionsListener]);
	}

}

export default new ProductListings();
